import React, { useState, useEffect } from "react";
import { Modal } from "../modal/Modal";
import Login from "./Login";
import SignIn from "./SignIn";

function Register({
    modalShow,
    setModalShow,
    login,
    setLogin,
    signIn,
    setSignIn,
}) {
    const closeModal = (e) => {
        setModalShow(false);
    };

    const tabToggle = (id) => {
        // console.log(id);
        switch (id) {
            case "1":
                setLogin(true);
                setSignIn(false);
                break;

            case "2":
                setLogin(false);
                setSignIn(true);
                break;
            // default:
            //     console.log("def");
        }
    };
    return (
        <div>
            <Modal show={modalShow} closeModal={closeModal}>
                <button
                    href="#"
                    className="btn-sm btn-circle absolute right-14 top-16 text-black text-2xl"
                    onClick={closeModal}
                >
                    ✕
                </button>
                <div className=" flex items-center justify-center flex-col">
                    <div className="tabs mb-8">
                        <a
                            className={`tab tab-bordered tab-lg ${
                                login ? "tab-active" : ""
                            }`}
                            id={1}
                            onClick={(event) =>
                                tabToggle(event.currentTarget.id)
                            }
                        >
                            ورود
                        </a>
                        <a
                            className={`tab tab-bordered tab-lg ${
                                signIn ? "tab-active" : ""
                            }`}
                            id={2}
                            onClick={(event) =>
                                tabToggle(event.currentTarget.id)
                            }
                        >
                            ثبت نام
                        </a>
                    </div>
                    <div>
                        {login ? (
                            <Login closeModal={closeModal} />
                        ) : signIn ? (
                            <SignIn
                                closeModal={closeModal}
                                setLogin={setLogin}
                                setSignIn={setSignIn}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default Register;
